import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../api/auth.service';
import { AccountType } from '../../constants/account-types';
import { QuestionState } from '../models';
import { QuestionPubSub } from '../question-runner/pubsub/question-pubsub';
import { UrlLoaderService } from '../url-loader.service';
import { IContentElementSolution } from './model';
import { TextToSpeechService } from '../text-to-speech.service';
import { Subject } from 'rxjs';
import { LangService } from '../../core/lang.service';
import { PageModalController, PageModalService } from 'src/app/ui-partial/page-modal.service';

enum Modal {
  POP_UP_CONTENT = "POP_UP_CONTENT"
}

export const isSolutionHeaderVisible = (element: IContentElementSolution) => {
  return !element.isRubric && !element.isHeaderHidden;
}
@Component({
  selector: 'element-render-solution',
  templateUrl: './element-render-solution.component.html',
  styleUrls: ['./element-render-solution.component.scss']
})
export class ElementRenderSolutionComponent implements OnInit {

  private static nextInstanceId = 0;

  @Input() element:IContentElementSolution;
  @Input() isLocked:boolean;
  @Input() isShowSolution:boolean;
  @Input() questionState:QuestionState;
  @Input() questionPubSub?: QuestionPubSub;
  readonly instanceId = `element-solution-${ElementRenderSolutionComponent.nextInstanceId++}`;
  Modal = Modal

  audioTrigger = new Subject();

  isSolutionHeaderVisible() {
    return isSolutionHeaderVisible(this.element);
  } 
  
  pageModal!: PageModalController;
  constructor(private auth: AuthService,
        private urlLoader: UrlLoaderService,
        private text2Speech: TextToSpeechService,
        private lang: LangService,
        private pageModalService: PageModalService,
    ) { }

  ngOnInit() {
    this.pageModal = this.pageModalService.defineNewPageModal()
  }

  getHeaderId() {
    return `${this.instanceId}-heading`;
  }

  cModal() { return this.pageModal.getCurrentModal(); }

  openZoomInModal(){
    const modalElement = document.querySelector('#customModalSolutionBlockWrapper'); 
    const originalParent = modalElement?.parentElement;
    if (modalElement) {
    document.body.appendChild(modalElement);
    }
    this.pageModal.newModal({
      type: Modal.POP_UP_CONTENT,
      config: {},
      finish: () => {
        if (modalElement && originalParent) {
          originalParent.appendChild(modalElement);
        }
          
          this.pageModal.closeModal();
        },
      isProceedOnly: true
    });
  }

  isVisible() {
    if(this.element.hideFromTestTakers) {
      try {
        return this.isLocked && this.auth.user().value.accountType !== AccountType.TEST_TAKER; //TODO: make invisible to test-takers (including preview as test-taker). for purposes of demo/review leave as is, but we should also hide when previewing as test-taker
      }
      catch (e){
        return false;
      }
    }
    return this.isLocked;
  }

  sanitizeUrl(url:string){
    return this.urlLoader.sanitize(url);
  }

  isVoiceoverEnabled() {
    return this.text2Speech.isActive
  }

  getText(slug:string) {
    return this.lang.tra(slug);
  }
}
